import { TransactionRequestEtisalatInputParamsModel, TransactionRequestPayWCreditCardInputParamsModel, TransactionRequestPayWDefinedCardInputParamsModel } from "src/app/card-operations-core/models/transaction-request-models";
import { IOnlineChargeMediator, OnlineChargeEvents } from "../components/online-charge-components/utility-classes/online-charge-classes";
import { IFirstStepComplete, PaymentTypeModel } from "../models/paymenType.model";

export interface ICardOperationsMediator extends IOnlineChargeMediator{
    notifyOnlineCharge(sender: object, eventName: string, message: object | string): void
    onNextTab(): void
}

export abstract class CardOperationsMediator implements ICardOperationsMediator{
    public onlineChargeTabGroupIndex = 0;
    public firstStepEmission!: IFirstStepComplete;
    public onlineChargeEvent: OnlineChargeEvents = "INITIAL_STATE";

    queryAlias = '';
    public selectedPaymentType!: PaymentTypeModel;
    public etisalatRequiredParams!: TransactionRequestEtisalatInputParamsModel;  

    notifyOnlineCharge(sender: object, eventName: string, message: object | string): void {}
    onNextTab(): void {}
}

export class EtisalatCardOperationsMediator extends CardOperationsMediator{

  public notifyOnlineCharge(sender: object, eventName: OnlineChargeEvents, message: object | string): void {
    if(eventName == "AMOUNT_SELECTED"){
      const emission = message as IFirstStepComplete;

      this.firstStepEmission = emission;
      this.queryAlias = emission.queryAlias;

      this.etisalatRequiredParams = {
        amount: String(emission.selectedChargeAmount),
        media_no: emission.cardAlias,
        product_code: emission.product_code,
        product_type: emission.product_type,
        totalAmount: String(emission.selectedChargeTotalAmount),
        media_type: emission.media_type,
        price: emission.price
      };
  
      this.selectedPaymentType = "etisalat";
  
      this.onNextTab();
    }else if(eventName == "TERMS_AGREED"){
      this.onNextTab();
    }else{
      throw new Error('UNKNOWN ONLINE CHARGE EVENT');
    }
    
    this.onlineChargeEvent = eventName;
  }    

  onNextTab = () => {
    this.onlineChargeTabGroupIndex = this.onlineChargeTabGroupIndex + 1;
  }
    
}